var $9d6fce77106482c8$exports = {};
$9d6fce77106482c8$exports = {
  "pending": `Ausstehend`
};
export { $9d6fce77106482c8$exports as default };